function q(o, v, z = false) {
    typeof o == "string" && (o = o.replace(".", ""));
    let d = "";
    const m = /\{\{\s*(\w+)\s*\}\}/,
        g = v || "${{amount}}";
    function f(e, n) {
        return typeof e > "u" ? n : e;
    }
    function t(e, n, c, p) {
        if (((n = f(n, 2)), (c = f(c, ",")), (p = f(p, ".")), isNaN(e) || e == null)) return 0;
        e = (e / 100).toFixed(n);
        const r = e.split("."),
            y = r[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + c),
            h = r[1] ? p + r[1] : "";
        return y + h;
    }
    switch (g.match(m)[1]) {
        case "amount":
            d = t(o, 2);
            break;
        case "amount_no_decimals":
            d = t(o, 0);
            break;
        case "amount_with_comma_separator":
            d = t(o, 2, ".", ",");
            break;
        case "amount_no_decimals_with_comma_separator":
            d = t(o, 0, ".", ",");
            break;
        case "amount_with_apostrophe_separator":
            d = t(o, 2, "'", ".");
            break;
    }
    if(z) return d;
    return g.replace(m, d);
}
(function () {
    var z = false;
    function o(t, e, n) {
        if (t != null) return (t.innerHTML = '<span class="money">' + q(e, n,z) + "</span>");
    }
    function v(t, e) {
        return t.sellingPlans.find((n) => n.id === Number(e));
    }
    function d(t) {
        let e = t.querySelector('input[name="selling_plan"]');
        return e || ((e = document.createElement("input")), (e.type = "hidden"), (e.name = "selling_plan"), t.append(e)), e;
    }
    function m(t, e, n) {
        const c = Array.from(document.querySelectorAll('form[action$="/cart/add"]')),
            p = c.map(d),
            r = document.querySelector("#juo-subscription-widget"),
            y = r.querySelector('[part="subscription-price"]'),
            h = r.querySelector('[part="price price--base"]'),
            S = r.querySelector('[part="compare-price"]'),
            l = r.querySelector('[part="select"]');
            z = r.classList.contains("juo-remove-curr");
        function w() {
            return r.querySelector("input[type=radio]:checked").value;
        }
        function E() {
            return w() === "onetime" ? "" : r.querySelector("select").value;
        }
        function L() {
            const a = E();
            p.forEach((i) => {
                i.value = a;
            });
        }
        function P() {
            const i = new URL(window.location.href).searchParams.get("variant") || e;
            return t.find(({ id: s }) => s == i) || t.find(Boolean);
        }
        function b(a = [], i) {
            if (l.dataset.activeVariant === String(i)) return;
            let s = "";
            if (
                (a.forEach((u) => {
                    s += `<option value="${u.id}">${u.name}</option>`;
                }),
                (l.innerHTML = s),
                a.length === 0)
            ) {
                l.value = "";
                return;
            }
            (l.dataset.activeVariant = i), (l.value = (l == null ? void 0 : l.children[0]).value), L();
        }
        function M(a, i) {
            c.forEach((s) => {
                const u = s.querySelector(".price-list .price:not(.price--compare)");
                u && (u.classList.contains("recharge-inner-most-price") || u.classList.add("recharge-inner-most-price"), (u.textContent = q(a, i)));
            });
        }
        function k() {
            const a = P(),
                i = v(a, l.value);
            b(a.sellingPlans, a.id);
            const s = w(),
                u = r.querySelector(".rc-selling-plans.rc_widget__option__plans");
            const sid = r.querySelector("select").value;
            let bag = 1, month = 1, month_denominator = 1;
            if(sid.length){
                const sp = r.querySelector(`option[value="${sid}"]`).innerText.match(/\d+/g);
                const package = r.querySelector('input[name="manual_package"]').value;
                month_denominator = r.querySelector('input[name="two_month"]') == null ? 1 : 2;
                if(sp) {
                    bag = parseInt(sp[0]) / parseInt(package);
                    month = parseInt(sp[1]);
                }
            }
            //if ((u && (u.style.display = s === "onetime" ? "none" : ""), i == null)) {
            r.querySelector("[data-option-subsave]").classList.toggle('rc-option--active', s !== "onetime")
            r.querySelector("[data-option-onetime]").classList.toggle('rc-option--active', s === "onetime")
            if ((u && i == null)) {
                r == null || r.classList.add("juo-hidden");
                return;
            } else r == null || r.classList.remove("juo-hidden");
            o(h, a.price, n), o(y, i.price / month_denominator, n), M(s === "onetime" ? a.price : i.price, n), i.price < i.comparePrice && a.price !== i.price ? o(S, i.comparePrice, n) : S && (S.innerHTML = "");
            r.querySelector('.juo-total-price').innerText = month == 1 ? '' : `${q(i.price*bag, n)} per ${month} maanden`
        }
        function _() {
            L(), k();
        }
        _(),
            document.addEventListener("change", _),
            l.addEventListener("change", () => {
                r.querySelector('input[type=radio][value="subsave"]').click(), r.querySelectorAll("input[type=radio]").forEach((a) => a.addEventListener("change", _));
            });
    }
    function g() {
        const t = document.querySelectorAll('form[action$="/cart/add"]'),
            e = new MutationObserver(() => {
                t.forEach((n) => {
                    const c = n.querySelector(".rc-container-wrapper.rc_container_wrapper:not(.juo-custom)");
                    c && c.remove();
                });
            });
        t.forEach((n) => e.observe(n, { attributes: !1, childList: !0, subtree: !1 }));
    }
    function f() {
        if (window.Shopify != null) {
            let t = function () {
                var p;
                const [e, n, c] = JSON.parse(((p = document.getElementById("juo-subscription-widget-data")) == null ? void 0 : p.innerText) ?? "[]");
                m(e, n, c), g();
            };
            document.readyState === "complete" || document.readyState === "interactive" ? t() : document.addEventListener("DOMContentLoaded", t);
        }
    }
    document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", f) : f();
})();
